<template>
  <canvas id="page1" v-bind="canvasAttrs"></canvas>
</template>

<script>
  import debug from 'debug';

  const log = debug('app:vue_features/documents/components/PDFPage');

  export default {
    // props: ['page', 'scale'],
    props: {
      page: {
        type: Object, // instance of PDFPageProxy returned from pdf.getPage
        required: true,
      },
      scale: {
        type: Number,
        required: true,
      },
    },

    computed: {
      actualSizeViewport() {
        return this.viewport.clone({scale: this.scale});
      },

      canvasStyle() {
        const {width: actualSizeWidth, height: actualSizeHeight} = this.actualSizeViewport;
        const pixelRatio = window.devicePixelRatio || 1;
        const [pixelWidth, pixelHeight] = [actualSizeWidth, actualSizeHeight].map(dim => Math.ceil(dim / pixelRatio));
        return `width: ${pixelWidth}px; height: ${pixelHeight}px;`
      },

      canvasAttrs() {
        let {width, height} = this.viewport;
        // let {width, height} = this.actualSizeViewport;
        // [width, height] = [width, height].map(dim => Math.ceil(dim));
        [width, height] = [width, height].map(dim => Math.ceil(dim));
        // let width = '800px';
        // let height = '1000px';

        const style = this.canvasStyle;

        return {
          height,
          width,
          style,
          class: 'pdf-page box-shadow',
        };
      },

      pageNumber() {
        return this.page.pageNumber;
      },
    },

    methods: {
      renderPage() {
        // PDFPageProxy#render
        // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
        this.renderTask = this.page.render(this.getRenderContext());
        // this.renderTask.then(() => this.$emit('rendered', this.page)).then(() => log(`Page ${this.pageNumber} rendered`));
      },

      destroyPage(page) {
        if (!page) return;

        // PDFPageProxy#_destroy
        // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
        page._destroy();

        // RenderTask#cancel
        // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
        if (this.renderTask) this.renderTask.cancel();
      },

      getRenderContext() {
        const {viewport} = this;
        const canvasContext = this.$el.getContext('2d');

        return {canvasContext, viewport};
      },
    },

    watch: {
      page(page, oldPage) {
        this.destroyPage(oldPage);
      },
    },

    created() {
      // PDFPageProxy#getViewport
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      let scale = this.scale;
      let rotation = 0;
      let dontFlip = false;
      // console.log('viewport: ', this.page.getViewport({ scale, rotation, dontFlip }))
      // this.viewport = this.page.getViewport(this.scale);
      this.viewport = this.page.getViewport({ scale, rotation, dontFlip });
    },

    mounted() {
      log(`Page ${this.pageNumber} mounted`);
      this.renderPage();
    },

    beforeDestroy() {
      this.destroyPage(this.page);
    },

    render(h) {
      const {canvasAttrs: attrs} = this;
      return h('canvas', {attrs});
    },
  };
</script>
<style>
  .pdf-page {
    display: block;
    margin: 0 auto 0.5em;
  }
</style>
